module.exports = __webpack_public_path__ + "img/paintbrush-pencil.6f7392ba.svg";